export default __webpack_public_path__ + "f9ea73ee6abe012b08fc85b6548919d7.png";